/* eslint-disable import/prefer-default-export */
import axios from "axios";
import { getCookies } from "./CookiesUtil";

const defaultHeader = {
  "Content-Type": "application/json",
};

const BASE_URL = "https://australia-southeast1-front-endsolar-dev.cloudfunctions.net/fstapi";

axios.interceptors.request.use((req) => {
  if (getCookies("AUTH_TOKEN")) {
    req.headers.Auth = getCookies("AUTH_TOKEN");
  }
  // Important: request interceptors **must** return the request.
  return req;
});

axios.interceptors.response.use((res) => {
  // Important: response interceptors **must** return the response.
  return res;
});

/**
 * Api wrapper Service for all Method
 * @param {string} url
 * @param {object} header
 * @param {object} params
 */
export const makeApiCall = async (parameter) => {
  try {
    const response = await axios({
      method: parameter.method,
      url: parameter.url,
      baseURL: BASE_URL,
      params: parameter.params,
      data: parameter.request,
      headers: parameter.header ? parameter.header : defaultHeader,
      proxy: true,
    });
    return response;
  } catch (error) {
    // eslint-disable-next-line no-empty
    if (error && error.response && error.response.status === 401) {
      return error.response;
    }
    if (error && error.response && error.response.status === 500) {
      return error.response;
    }
    if (error && error.response && error.response.status === 404) {
      return error.response;
    }
    return error;
  }
};
